/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { overflowEllipsis } from 'src/styles/mixins';

export const IssueLink = styled.a({
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  '&, &:hover, &:focus': {
    color: token('color.text'),
  },
});

export const JiraIssueTypeIconContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const JiraIssueTypeIcon = styled.img({
  flexShrink: 0,
  width: `${gridSize() * 2}px`,
  height: `${gridSize() * 2}px`,
  paddingRight: `${gridSize()}px`,
});

export const IssueKey = styled.span({
  paddingRight: `${gridSize()}px`,
  color: token('color.text.subtlest'),
  whiteSpace: 'nowrap',
});

export const IssueSummary = styled.div(overflowEllipsis());

export const IssueSummaryWrapper = styled.div({
  overflow: 'hidden',
});
